import { camelizeKeys } from 'humps';
import { schema } from 'normalizr';
import defaults from 'lodash/defaults';

import { ENTITIES_KEY_PROCESS } from '../constants/entityKeys';

export const processProcess = (processData) => {
    const process = defaults(camelizeKeys(processData), {
        completedAt: false,
        deleted: false,
        dismissed: false,
        isDeleting: false,
        isDismissing: false,
        onCompletedButton: null,
        eventId: null,
        meta: [],
    });

    // If the process has been marked as completed, we want to force it to
    // appear in the UI.
    if (process.completedAt) {
        process.dismissed = false;
    }
    // allowing old process tracker destination structure
    // todo: remove 'destination' option once no old process tracker are active
    // Make sure the destination id is always an integer
    if (process.destination && process.destination.id) {
        process.destination.id = parseInt(process.destination.id, 10);
    }

    // Make sure the destination id is always an integer
    if (process.destinations) {
        process.destinations = process.destinations.map((destination) => {
            const formattedDestination = { ...destination };
            formattedDestination.id = parseInt(formattedDestination.id, 10);
            return formattedDestination;
        });
    }

    return process;
};

export const processSchema = new schema.Entity(
    ENTITIES_KEY_PROCESS,
    {},
    {
        processStrategy: (entity) => processProcess(entity),
    },
);

export const processesSchema = [processSchema];
